import {uniqBy} from 'ramda'

import {UserSearchHistoryItem} from './types'

/**
 * Filters out unique searches from the user's search history.
 * Uniqueness is determined based on the presence of either
 * `hotelId`,`placeId`, `address` or `boundingBox` in the search parameters.
 * @param searchHistory - An array of {@link UserSearchHistoryItem}.
 * @returns An array consisting of unique {@link UserSearchHistoryItem} objects based on `hotelId`,`placeId`, 'address' or `boundingBox`.
 */
const selectUniqueSearches = (searchHistory: UserSearchHistoryItem[]) => {
  const getUniqueIdentifier = ({
    searchParams: {hotelId, placeId, address, boundingBox}
  }: UserSearchHistoryItem) => hotelId || placeId || address || boundingBox

  return uniqBy(getUniqueIdentifier, searchHistory)
}

export {selectUniqueSearches}
